export default __webpack_public_path__ + "static/media/reparatie_tuigage.a581c428.svg";